import { render, staticRenderFns } from "./CitizenPassportList.vue?vue&type=template&id=88b20ee4&scoped=true&"
import script from "./CitizenPassportList.vue?vue&type=script&lang=ts&"
export * from "./CitizenPassportList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b20ee4",
  null
  
)

export default component.exports